import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Typo } from 'tmt-ui-kit';
import config from '../../config';
import { getSessionStorageKey, setSessionStorageKey } from '../../utils/session-storage';

const ToastContainer = styled.div`
  position: fixed;
  left: 5%;
  right: 5%;
  top: 72px;
  background-color: rgba(242, 242, 242, 0.9);
  border-radius: 10px;
  z-index: 2147483647;
  padding: 8px;
`;

const InnerContainer = styled.div`
  position: relative;
`;

const CloseContainer = styled.div`
  position: absolute;
  right: 8px;
  top: 0;
  transform: scale(1.5);
`;

const Text = styled(Typo.Paragraph)`
  font-family: Montserrat, sans-serif;
  font-size: 12px !important;
  text-align: center;
  max-width: 80%;
  margin: 0 auto;
`;

const TGTHPartnerToast = () => {
  const [isSeen, setIsSeen] = useState(false);
  const affId = useSelector(state => state.app.affid);
  useEffect(() => {
    const isTGTHAffiliate = affId === config.tgthAffiliateId;
    const isAcceptedToast = getSessionStorageKey(config.tgthPartnerToastCookie);
    if (isTGTHAffiliate && !isAcceptedToast) {
      setIsSeen(true);
    }
  }, []);
  function onClose() {
    setIsSeen(false);
    setSessionStorageKey(config.tgthPartnerToastCookie, 'true');
  }
  if (!isSeen) return null;
  return (
    <ToastContainer>
      <InnerContainer>
        <Text>This service is provided by our partners. The search information will be forwarded to them for service fulfilment.</Text>
        <CloseContainer onClick={onClose}>
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0.591797L4 3.5918M7 6.5918L4 3.5918M4 3.5918L7 0.591797M4 3.5918L1 6.5918" stroke="#6E6F73" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </CloseContainer>
      </InnerContainer>
    </ToastContainer>
  );
};

export default TGTHPartnerToast;
